import { useState } from 'react';
import { ErrorText, GroupedCode, Page } from '../components';
import { useAction, useDevice, useSnapshot } from '../state';

/** Shows a new recovery code once. It is never stored, so it cannot be shown again. */
export function RecoveryCode() {
  const device = useDevice();
  const { recoveryCode } = useSnapshot();
  const { busy, error, run } = useAction();
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(recoveryCode ?? '');
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Page>
      <h1>Your recovery code</h1>
      <p>If you forget your password, this code is the only way to open your records again. Write it down and keep it somewhere safe, away from this device.</p>
      <GroupedCode code={recoveryCode ?? ''} breakAfter={3} label="Recovery code" testId="recovery-code" />
      <p className="muted">Curentia does not keep a copy. Anyone with this code and your backup file can open your records.</p>
      <div className="stack">
        <button type="button" className="button secondary" onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy the code'}
        </button>
        <label className="check">
          <input type="checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} />
          I have written down my recovery code
        </label>
        <ErrorText error={error} />
        <button type="button" className="button" disabled={!saved || busy} onClick={() => void run(() => device.confirmRecoveryCode())}>
          Continue
        </button>
      </div>
    </Page>
  );
}
